// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.customsCodes', {
    url: '/customs-codes',
    templateUrl: 'main/configuration/customsCodes/customsCodes.tpl.html',
    data: { pageTitle: 'Customs codes' },
  });
};

angular.module('configuration.customsCodes', []).config(config);
